const LAST_PREFIX = 'portal.listQuery.last.'
const RECENT_PREFIX = 'portal.listQuery.recent.'
export const LIST_QUERY_RECENT_MAX = 10

function safeParse(raw) {
  if (!raw) return null
  try {
    return JSON.parse(raw)
  } catch {
    return null
  }
}

export function getLastQuery(routeKey) {
  if (typeof sessionStorage === 'undefined') return null
  try {
    return safeParse(sessionStorage.getItem(`${LAST_PREFIX}${routeKey}`))
  } catch {
    return null
  }
}

export function setLastQuery(routeKey, filters) {
  if (typeof sessionStorage === 'undefined') return
  try {
    sessionStorage.setItem(`${LAST_PREFIX}${routeKey}`, JSON.stringify(filters))
  } catch {
    // quota / private mode
  }
}

export function getRecentQueries(routeKey) {
  if (typeof localStorage === 'undefined') return []
  try {
    const list = safeParse(localStorage.getItem(`${RECENT_PREFIX}${routeKey}`))
    return Array.isArray(list) ? list : []
  } catch {
    return []
  }
}

/**
 * Push a recent entry. Dedupes by stable label+params signature.
 * @param {string} routeKey
 * @param {object} filters
 * @param {string} label
 */
export function pushRecent(routeKey, filters, label) {
  if (typeof localStorage === 'undefined') return
  const entry = {
    label: label || 'Filters',
    filters,
    at: Date.now(),
  }
  try {
    const prev = getRecentQueries(routeKey)
    const sig = JSON.stringify(filters)
    const next = [
      entry,
      ...prev.filter((item) => JSON.stringify(item.filters) !== sig),
    ].slice(0, LIST_QUERY_RECENT_MAX)
    localStorage.setItem(`${RECENT_PREFIX}${routeKey}`, JSON.stringify(next))
  } catch {
    // ignore
  }
}

export function clearRouteHistory(routeKey) {
  try {
    if (typeof sessionStorage !== 'undefined') {
      sessionStorage.removeItem(`${LAST_PREFIX}${routeKey}`)
    }
  } catch {
    // ignore
  }
  try {
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(`${RECENT_PREFIX}${routeKey}`)
    }
  } catch {
    // ignore
  }
}
